"use client";

// import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export default function Loader() {
	// const pathname = usePathname();
	const [progress, setProgress] = useState(60);
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setProgress(100);

			setTimeout(() => {
				setHidden(true);
				setProgress(0);
			}, 200);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div
			className={`h-[2px] bg-red-500 fixed top-0 left-0 transition-all duration-300 ${hidden ? "opacity-0 w-0" : "opacity-100 w-full z-[70]"}`}
			style={{
				width: `${progress}%`,
				transition: progress === 100 ? "none" : "width 0.3s ease-in-out",
			}}
		/>
	);
}
